import React from "react"
import { useTranslation } from "react-i18next"
import { useMediaQuery } from "react-responsive"
import { CONSULT_STATUS } from "src/modules/const"
import { Typography } from "src/UILibrary"

interface Props {
  status: string
}

export const ConsultStatusLabel = ({ status }: Props) => {
  const { t } = useTranslation("translation", { keyPrefix: "mypage.inbox" })
  const isSmall = useMediaQuery({ query: "(min-width: 700px)" })

  return (
    <>
      {status === CONSULT_STATUS.RESERVED && (
        <Typography.InputFieldRequired
          sx={{
            p: "0px 10px",
            width: "fit-content",
            color: "#235496",
            borderWidth: "1px",
            borderStyle: "solid",
            borderRadius: "4px",
            borderColor: "#235496",
            fontSize: "13px",
            my: isSmall ? "auto" : "3px",
          }}
        >
          {t("consult_reserved")}
        </Typography.InputFieldRequired>
      )}
      {status === CONSULT_STATUS.ACCEPTED && (
        <Typography.InputFieldRequired
          sx={{
            p: "0px 10px",
            width: "fit-content",
            color: "#FB6F92",
            borderWidth: "1px",
            borderStyle: "solid",
            borderRadius: "4px",
            borderColor: "#FB6F92",
            fontSize: "13px",
            my: isSmall ? "auto" : "3px",
          }}
        >
          {t("consult_accepted")}
        </Typography.InputFieldRequired>
      )}
      {status === CONSULT_STATUS.FINISHED && (
        <Typography.InputFieldRequired
          sx={{
            p: "0px 10px",
            width: "fit-content",
            color: "#388E3C",
            borderWidth: "1px",
            borderStyle: "solid",
            borderRadius: "4px",
            borderColor: "#388E3C",
            fontSize: "13px",
            my: isSmall ? "auto" : "3px",
          }}
        >
          {t("consult_finished")}
        </Typography.InputFieldRequired>
      )}
      {status === CONSULT_STATUS.RESIGNED && (
        <Typography.InputFieldRequired
          sx={{
            p: "0px 10px",
            width: "fit-content",
            color: "#F57C00",
            borderWidth: "1px",
            borderStyle: "solid",
            borderRadius: "4px",
            borderColor: "#F57C00",
            fontSize: "13px",
            my: isSmall ? "auto" : "3px",
          }}
        >
          {t("consult_resigned")}
        </Typography.InputFieldRequired>
      )}
      {status === CONSULT_STATUS.CANCELED && (
        <Typography.InputFieldRequired
          sx={{
            p: "0px 10px",
            width: "fit-content",
            color: "#998E8A",
            borderWidth: "1px",
            borderStyle: "solid",
            borderRadius: "4px",
            borderColor: "#998E8A",
            fontSize: "13px",
            my: isSmall ? "auto" : "3px",
          }}
        >
          {t("consult_cancelled")}
        </Typography.InputFieldRequired>
      )}
    </>
  )
}
